/**
 * Checks if a phone number is a special number (N11 number or 988 crisis number)
 * @param phoneNumber - The phone number to check
 * @returns true if the phone number is a special number, false otherwise
 */
export const isSpecialPhoneNumber = (phoneNumber: string): boolean => {
  const specialNumberRegex = /^(211|311|411|511|711|811|988)$/;
  return specialNumberRegex.test(phoneNumber);
};
